import { resolveRoleIds } from 'ClientService';
import { Store }          from 'Redux/Config';
import { userContainsRole } from 'Redux/Query';
import * as ROLES from 'AppConfig/Config'

export const HasNot = (Roles) => {
  const state = Store.getState();
  const checkUserRole = userContainsRole(state);

  const _roles = Roles.filter((role) => ROLES[role]).map(role => ROLES[role]);
  return !checkUserRole(_roles);
};
